<template>
  <div id="footer" class="acea-row row-middle">
    <div @click="goPath(item.url)"
      class="item" :class="{ on: item.url === $route.path }" v-for="(item, index) in footerList" :key="index">
    <!-- <div    class="iconfont"    :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"  > -->
      <div class="iconfont" style="padding-top: 3px;box-sizing: border-box;">
      <img :width="item.width" :height="item.height" :src="item.url === $route.path ? item.img2:item.img1" alt="">
    </div>
      <div>{{$t(item.name)}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: 'message.footer.home',
          icon1: "icon-shouye-xianxing",
          icon2: "icon-shouye",
          img1:require("@assets/images/home.png"),
          img2:require("@assets/images/homeA.png"),
          width:'19px',
          height:'19px',
          url: "/",
          routerName:'Index'
        },
        {
          name: 'message.footer.points',
          icon1: "icon-yingyongchengxu-xianxing",
          icon2: "icon-yingyongchengxu",
          img1:require("@assets/images/jifen.png"),
          img2:require("@assets/images/jifenA.png"),
          width:'19px',
          height:'17px',
          url: "/integral",
          routerName:'integral'
        },
        {
          name: 'message.footer.vip_zone',
          icon1: "icon-yingyongchengxu-xianxing",
          icon2: "icon-yingyongchengxu",
          img1:require("@assets/images/tabvip1.png"),
          img2:require("@assets/images/tabvip.png"),
          width:'28px',
          height:'28px',
          url: "/vip_goods_list",
          routerName:'VipGoodsList'
        },
        {
          name: 'message.footer.order',
          icon1: "icon-caigou-xianxing",
          icon2: "icon-caigou",
          img1:require("@assets/images/dingdan.png"),
          img2:require("@assets/images/dingdanA.png"),
          width:'17px',
          height:'19px',
          url: "/order/list/",
          routerName:'MyOrder'
        },
        {
          name: 'message.footer.account',
          icon1: "icon-yonghu-xianxing",
          icon2: "icon-yonghu",
          img1:require("@assets/images/wode.png"),
          img2:require("@assets/images/wodeA.png"),
          width:'16px',
          height:'19px',
          url: "/user",
          routerName:'User'

        }
      ]
    };
  },
  methods: {
    goPath(url){
      // console.log('gopath',url)
      this.$router.replace({path:url})
      // console.log(this.$router.replace({name:url}))
    }
  }
};
</script>
